
/**
 * Helper untuk mencetak tanggal dalam format aksara bali
 *
 * @author Ngurah Mahaputra
 * @version 1.0
 */

/**
 * Fungsi untuk merubah hari bahasa inggris menjadi aksara bali
 * @return string nama hari dalam aksara bali
 */

    function hari(time){
        const t = new Date(time);
        
        let day;
        switch (t.getDay()) {
            case 1:
                day = "ᬲᭀᬫ";
                break;
            case 2:
                day = "ᬳᬗ᭄ᬕᬭ";
                break;
            case 3:
                day = "ᬩᬸᬥ᭄ᬤ";
                break;
            case 4:
                day = "ᬯᬺᬱ᭄ᬧᬢᬶ";
                break;
            case 5:
                day = "ᬲᬸᬓ᭄ᬭ";
                break;
            case 6:
                day = "ᬲᬦᬶᬰ᭄ᬘᬭ";
                break;
            case 0:
                day = "ᬋᬤᬶᬢᬾ";
                break;
            
            default:
                day = "InternalError";
                break;
        }
        return day;
    }

/**
 * Fungsi untuk merubah  angka menjadi angka aksara bali
 * @param int 
 * @return string nama angka dalam aksara bali
 */
    function bali_number(number){
      for(let i=0;i<number.length;i++){
        number = number.replace("1","᭑");
        number = number.replace("2","᭒");
        number = number.replace("3","᭓");
        number = number.replace("4","᭔");
        number = number.replace("5","᭕");
        number = number.replace("6","᭖");
        number = number.replace("7","᭗");
        number = number.replace("8","᭘");
        number = number.replace("9","᭙");
        number = number.replace("0","᭐");}
        return number;}
    

/**
 * Fungsi untuk membuat tanggal dalam format aksara bali
 * @return string 
 */
 function tanggal(time) {
      const date = new Date(time);
      const tanggal = hari(time) + " , "+date.getDate()+ " / " +String(parseInt(date.getMonth())+1)+" / "+date.getFullYear();
        return bali_number(tanggal);
    }

export default tanggal